export const CAIP_NAMESPACE = 'bip122';
export const CAIP_BITCOIN_CHAIN_ID = '000000000019d6689c085ae165831e93';
